import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mc-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})

export class NavigationBarComponent implements OnInit {
  private _title!: string;
  constructor() { }

  ngOnInit() {
    // console.log(this._title);
  }

  @Input()
  get title(): string {
    return this._title;
  }

  set title(title: string) {
    // console.log("title is",title);
    this._title = title;
  }
}
